// Static product data store for development and testing
// This will be replaced by real API data later

import { IProduct } from "@/lib/types/productType";

// Static product listings for development
export const productListings: Record<number, IProduct> = {
  1: {
    id: 1,
    title: "Vintage Jacket",
    price: "€150",
    description: "Classic vintage Suede jacket in excellent condition. Perfect for collectors and fashion enthusiasts. Brown distressed Suede with authentic patina.",
    image: "/images/1_Vintage_Jacket.png",
    images: [
      "/images/1_Vintage_Jacket.png",
      "/images/1_Vintage_Jacket_2.png",
      "/images/1_Vintage_Jacket_3.png",
      "/images/1_Vintage_Jacket_4.png",
      "/images/1_Vintage_Jacket_5.png"
    ],
    stall: {
      id: 1,
      name: "Vintage Style Co.",
      description: "Curated collection of authentic vintage clothing and accessories from the 20th century.",
      products: [
        { id: 1, title: "Vintage Suede Jacket", price: "€150" },
        { id: 2, title: "Denim Jeans", price: "€80" },
        { id: 3, title: "Wool Sweater", price: "€65" },
      ],
    },
    category: { id: "cl-1-6", name: "Jackets" },
    condition: "Very Good",
    rating: 4.5,
    reviewCount: 23,
    stallName: "Vintage Style Co.",
    stallId: 1,
    isFeatured: false,
    hasFreeShipping: false,
    isOnSale: false,
    specifications: [
      { filterId: "size", value: "M", displayName: "Size" },
      { filterId: "material", value: "Suede", displayName: "Material" },
      { filterId: "style", value: "Vintage", displayName: "Style" },
      { filterId: "pattern", value: "Solid", displayName: "Pattern" },
      { filterId: "color", value: "Brown", displayName: "Color" },
    ]
  },
  2: {
    id: 2,
    title: "Handmade Ceramic Vase",
    price: "€75",
    description: "Beautiful handmade ceramic vase with unique glazing. Perfect for modern home decor. Crafted by local artisans.",
    image: "/images/2_Handmade_Ceramic_Vase.png",
    stall: {
      id: 2,
      name: "Lisboa Crafts",
      description: "Independent artisan collective selling handmade ceramics, textiles, and decor.",
      products: [
        { id: 2, title: "Handmade Ceramic Vase", price: "€75" },
        { id: 4, title: "Pottery Bowl", price: "€45" },
        { id: 5, title: "Decorative Plate", price: "€60" },
      ],
    },
    category: { id: "ac-4", name: "Ceramics" },
    condition: "Like New",
    rating: 4.8,
    reviewCount: 12,
    stallName: "Lisboa Crafts",
    stallId: 2,
    isFeatured: false,
    hasFreeShipping: true,
    isOnSale: false,
    specifications: [
      { filterId: "artType", value: "Ceramics", displayName: "Art Type" },
      { filterId: "medium", value: "Clay", displayName: "Medium" },
      { filterId: "handmade", value: "Handmade Only", displayName: "Handmade" },
      { filterId: "skillLevel", value: "Intermediate", displayName: "Skill Level" },
    ]
  },
  3: {
    id: 3,
    title: "Vintage Camera Collection",
    price: "€200",
    originalPrice: "€250",
    description: "Rare vintage camera collection including original case and accessories. Perfect for photography collectors.",
    image: "/images/3_Vintage_Camera_Collection.png",
    images: [
      "/images/3_Vintage_Camera_Collection.png",
      "/images/3_Vintage_Camera_Collection_2.png",
      "/images/3_Vintage_Camera_Collection_3.png"
    ],
    variants: [
      // Electronics variant structure - different from clothing
      {
        id: "storage-8gb",
        name: "Storage",
        value: "8GB",
        price: "€180",
        stock: 3,
        colors: [
          { id: "color-black", name: "Color", value: "Black", price: "€180", stock: 2 },
          { id: "color-silver", name: "Color", value: "Silver", price: "€180", stock: 1 }
        ]
      },
      {
        id: "storage-16gb",
        name: "Storage",
        value: "16GB",
        price: "€200",
        stock: 5,
        colors: [
          { id: "color-black", name: "Color", value: "Black", price: "€200", stock: 3 },
          { id: "color-silver", name: "Color", value: "Silver", price: "€200", stock: 2 },
          { id: "color-gold", name: "Color", value: "Gold", price: "€220", stock: 1 }
        ]
      },
      {
        id: "storage-32gb",
        name: "Storage",
        value: "32GB",
        price: "€250",
        stock: 2,
        colors: [
          { id: "color-black", name: "Color", value: "Black", price: "€250", stock: 1 },
          { id: "color-silver", name: "Color", value: "Silver", price: "€250", stock: 1 }
        ]
      }
    ],
    stall: {
      id: 3,
      name: "Retro Finds",
      description: "Specializing in vintage electronics and collectibles from the 20th century.",
      products: [
        { id: 3, title: "Vintage Camera Collection", price: "€200" },
        { id: 6, title: "Old Radio", price: "€85" },
        { id: 7, title: "Typewriter", price: "€180" },
      ],
    },
    category: { id: "co-3", name: "Cameras" },
    condition: "Good",
    rating: 4.2,
    reviewCount: 45,
    stallName: "Retro Finds",
    stallId: 3,
    isFeatured: true,
    hasFreeShipping: false,
    isOnSale: true,
    specifications: [
      { filterId: "collectibleType", value: "Cameras", displayName: "Collectible Type" },
      { filterId: "era", value: "1950s", displayName: "Era" },
      { filterId: "rarity", value: "Rare", displayName: "Rarity" },
      { filterId: "certified", value: "Original Packaging", displayName: "Certification" },
    ]
  },
  4: {
    id: 4,
    title: "Antique Coffee Table",
    price: "€350",
    description: "Beautiful antique wooden coffee table with intricate carvings. Perfect centerpiece for any living room.",
    image: "/images/4_Antique_Coffee_Table.png",
    stall: {
      id: 4,
      name: "Heritage Pieces",
      description: "Specializing in antique furniture and home decor items.",
      products: [
        { id: 4, title: "Antique Coffee Table", price: "€350" },
        { id: 8, title: "Vintage Chair", price: "€180" },
        { id: 9, title: "Wooden Cabinet", price: "€420" },
      ],
    },
    category: { id: "hg-1-1", name: "Coffee Tables" },
    condition: "Very Good",
    rating: 4.7,
    reviewCount: 18,
    stallName: "Heritage Pieces",
    stallId: 4,
    isFeatured: true,
    specifications: [
      { filterId: "height", value: 45, displayName: "Height", },
      { filterId: "width", value: 120, displayName: "Width", },
      { filterId: "depth", value: 80, displayName: "Depth", },
      { filterId: "weightCapacity", value: "Up to 50kg", displayName: "Weight Capacity", },
      { filterId: "assembly", value: "No Assembly", displayName: "Assembly Required", },
      { filterId: "indoorOutdoor", value: "Indoor Only", displayName: "Usage", },
    ]
  },
  5: {
    id: 5,
    title: "Vintage Vinyl Records",
    price: "€25",
    description: "Collection of classic vinyl records from the 60s and 70s. Includes Beatles, Rolling Stones, and more.",
    image: "/images/5_Vintage_Vinyl_Records.png",
    stall: {
      id: 5,
      name: "Music Memorabilia",
      description: "Rare vinyl records and music memorabilia from various eras.",
      products: [
        { id: 5, title: "Vintage Vinyl Records", price: "€25" },
        { id: 10, title: "Record Player", price: "€120" },
        { id: 11, title: "Concert Posters", price: "€40" },
      ],
    },
    category: { id: "co-6", name: "Vintage Items" },
    condition: "Good",
    rating: 4.6,
    reviewCount: 32,
    stallName: "Music Memorabilia",
    stallId: 5,
    isFeatured: true,
    specifications: [
      { filterId: "collectibleType", value: "Music", displayName: "Collectible Type" },
      { filterId: "era", value: "1960s", displayName: "Era" },
      { filterId: "rarity", value: "Common", displayName: "Rarity" },
      { filterId: "certified", value: "Not Certified", displayName: "Certification" },
    ]
  },
  6: {
    id: 6,
    title: "Retro Gaming Console",
    price: "€180",
    description: "Classic gaming console from the 80s with original controllers and games. Fully functional.",
    image: "/images/6_Retro_Gaming_Console.png",
    stall: {
      id: 6,
      name: "Pixel Palace",
      description: "Vintage gaming consoles and classic video games.",
      products: [
        { id: 6, title: "Retro Gaming Console", price: "€180" },
        { id: 12, title: "Game Cartridges", price: "€15" },
        { id: 13, title: "Gaming Magazine", price: "€8" },
      ],
    },
    category: { id: "el-5", name: "Gaming" },
    condition: "Very Good",
    rating: 4.4,
    reviewCount: 28,
    stallName: "Pixel Palace",
    stallId: 6,
    isFeatured: false,
    specifications: [
      { filterId: "brand", value: "Nintendo", displayName: "Brand" },
      { filterId: "storage", value: "Up to 64GB", displayName: "Storage Capacity" },
      { filterId: "connectivity", value: ["Wi-Fi", "USB-A", "3.5mm Audio"], displayName: "Connectivity" },
    ]
  },
  7: {
    id: 7,
    title: "Vintage Denim Jeans",
    price: "€80",
    originalPrice: "€180",
    description: "Classic Levi's denim jeans from the 70s. Perfect vintage fit with authentic wear patterns.",
    image: "/images/7_Vintage_Denim_Jeans.png",
    stall: {
      id: 1,
      name: "Vintage Style Co.",
      description: "Curated collection of authentic vintage clothing and accessories.",
      products: [
        { id: 1, title: "Vintage Suede Jacket", price: "€150" },
        { id: 2, title: "Denim Jeans", price: "€80" },
        { id: 7, title: "Vintage Denim Jeans", price: "€80" },
      ],
    },
    category: { id: "cl-7", name: "Vintage" },
    condition: "Good",
    rating: 4.3,
    reviewCount: 19,
    stallName: "Vintage Style Co.",
    stallId: 1,
    isFeatured: true,
    hasFreeShipping: true,
    isOnSale: true,
    specifications: [
      { filterId: "size", value: "32", displayName: "Size" },
      { filterId: "material", value: "Denim", displayName: "Material" },
      { filterId: "style", value: "Classic", displayName: "Style" },
      { filterId: "pattern", value: "Solid", displayName: "Pattern" },
      { filterId: "color", value: "Blue", displayName: "Color" },
    ]
  },
  8: {
    id: 8,
    title: "Antique Copper Lamp",
    price: "€95",
    description: "Beautiful antique Copper lamp with original shade. Perfect for adding vintage charm to any room.",
    image: "/images/8_Antique_Copper_Lamp.png",
    stall: {
      id: 7,
      name: "Antique Lighting",
      description: "Specializing in vintage and antique lighting fixtures.",
      products: [
        { id: 8, title: "Antique Copper Lamp", price: "€95" },
        { id: 14, title: "Crystal Chandelier", price: "€300" },
        { id: 15, title: "Art Deco Lamp", price: "€150" },
      ],
    },
    category: { id: "hg-4", name: "Lighting" },
    condition: "Very Good",
    rating: 4.7,
    reviewCount: 15,
    stallName: "Antique Lighting",
    stallId: 7,
    isFeatured: true,
    specifications: [
      { filterId: "height", value: 60, displayName: "Height" },
      { filterId: "width", value: 30, displayName: "Width" },
      { filterId: "depth", value: 30, displayName: "Depth" },
      { filterId: "assembly", value: "No Assembly", displayName: "Assembly Required" },
      { filterId: "indoorOutdoor", value: "Indoor Only", displayName: "Usage" },
    ]
  },
  9: {
    id: 9,
    title: "Vintage Comic Books",
    price: "€45",
    description: "Collection of classic comic books from the 60s. Includes Superman, Batman, and Spiderman issues.",
    image: "/images/9_Vintage_Comic_Books.png",
    stall: {
      id: 8,
      name: "Comic Vault",
      description: "Rare comic books and graphic novels from various eras.",
      products: [
        { id: 9, title: "Vintage Comic Books", price: "€45" },
        { id: 16, title: "Graphic Novels", price: "€25" },
        { id: 17, title: "Comic Art", price: "€60" },
      ],
    },
    category: { id: "bk-6", name: "Rare Books" },
    condition: "Good",
    rating: 4.5,
    reviewCount: 22,
    stallName: "Comic Vault",
    stallId: 8,
    isFeatured: true,
    specifications: [
      { filterId: "genre", value: "Superhero", displayName: "Genre" },
      { filterId: "language", value: "English", displayName: "Language" },
      { filterId: "publicationYear", value: 1965, displayName: "Publication Year" },
      { filterId: "binding", value: "Paperback", displayName: "Binding" },
      { filterId: "condition", value: "Good", displayName: "Book Condition" },
    ]
  },
  10: {
    id: 10,
    title: "Retro Record Player",
    price: "€120",
    description: "Classic record player from the 70s with built-in speakers. Fully restored and working condition.",
    image: "/images/10_Retro_Record_Player.png",
    stall: {
      id: 5,
      name: "Music Memorabilia",
      description: "Rare vinyl records and music memorabilia from various eras.",
      products: [
        { id: 5, title: "Vintage Vinyl Records", price: "€25" },
        { id: 10, title: "Record Player", price: "€120" },
        { id: 11, title: "Concert Posters", price: "€40" },
      ],
    },
    category: { id: "el-4", name: "Audio" },
    condition: "Very Good",
    rating: 4.6,
    reviewCount: 14,
    stallName: "Music Memorabilia",
    stallId: 5,
    isFeatured: true,
    specifications: [
      { filterId: "brand", value: "Sony", displayName: "Brand" },
      { filterId: "connectivity", value: ["3.5mm Audio", "RCA"], displayName: "Connectivity" },
      { filterId: "storage", value: "Built-in Speakers", displayName: "Audio Output" },
    ]
  },
  11: {
    id: 11,
    title: "Vintage Concert Posters",
    price: "€40",
    description: "Original concert posters from the 70s featuring classic rock bands. Perfect for music enthusiasts.",
    image: "/images/11_Vintage_Concert_Posters.png",
    stall: {
      id: 5,
      name: "Music Memorabilia",
      description: "Rare vinyl records and music memorabilia from various eras.",
      products: [
        { id: 5, title: "Vintage Vinyl Records", price: "€25" },
        { id: 10, title: "Record Player", price: "€120" },
        { id: 11, title: "Concert Posters", price: "€40" },
      ],
    },
    category: { id: "co-5-1", name: "Music" },
    condition: "Good",
    rating: 4.4,
    reviewCount: 8,
    stallName: "Music Memorabilia",
    stallId: 5,
    isFeatured: true,
    specifications: [
      { filterId: "artType", value: "Posters", displayName: "Art Type" },
      { filterId: "medium", value: "Paper", displayName: "Medium" },
      { filterId: "handmade", value: "Machine Made", displayName: "Handmade" },
      { filterId: "skillLevel", value: "Beginner", displayName: "Skill Level" },
    ]
  },
  12: {
    id: 12,
    title: "Game Cartridges",
    price: "€15",
    description: "Original game cartridges for retro gaming consoles. Includes popular titles from the 80s.",
    image: "/images/12_Game_Cartridges.png",
    stall: {
      id: 6,
      name: "Pixel Palace",
      description: "Vintage gaming consoles and classic video games.",
      products: [
        { id: 6, title: "Retro Gaming Console", price: "€180" },
        { id: 12, title: "Game Cartridges", price: "€15" },
        { id: 13, title: "Gaming Magazine", price: "€8" },
      ],
    },
    category: { id: "el-5-2", name: "Games" },
    condition: "Like New",
    rating: 4.2,
    reviewCount: 31,
    stallName: "Pixel Palace",
    stallId: 6,
    isFeatured: true,
    specifications: [
      { filterId: "brand", value: "Nintendo", displayName: "Brand" },
      { filterId: "storage", value: "Up to 64GB", displayName: "Storage Capacity" },
      { filterId: "connectivity", value: ["USB-A"], displayName: "Connectivity" },
    ]
  },
  13: {
    id: 13,
    title: "Vintage Gaming Magazine",
    price: "€8",
    description: "Classic gaming magazine from the 90s with reviews and previews of popular games.",
    image: "/images/13_Vintage_Gaming_Magazine.png",
    stall: {
      id: 6,
      name: "Pixel Palace",
      description: "Vintage gaming consoles and classic video games.",
      products: [
        { id: 6, title: "Retro Gaming Console", price: "€180" },
        { id: 12, title: "Game Cartridges", price: "€15" },
        { id: 13, title: "Gaming Magazine", price: "€8" },
      ],
    },
    category: { id: "bk-5", name: "Magazines" },
    condition: "Acceptable",
    rating: 4.0,
    reviewCount: 12,
    stallName: "Pixel Palace",
    stallId: 6,
    isFeatured: true,
    specifications: [
      { filterId: "genre", value: "Gaming", displayName: "Genre" },
      { filterId: "language", value: "English", displayName: "Language" },
      { filterId: "publicationYear", value: 1995, displayName: "Publication Year" },
      { filterId: "binding", value: "Paperback", displayName: "Binding" },
      { filterId: "condition", value: "Acceptable", displayName: "Book Condition" },
    ]
  },
  14: {
    id: 14,
    title: "Crystal Chandelier",
    price: "€300",
    description: "Elegant crystal chandelier from the early 20th century. Perfect for formal dining rooms.",
    image: "/images/14_Crystal_Chandelier.png",
    stall: {
      id: 7,
      name: "Antique Lighting",
      description: "Specializing in vintage and antique lighting fixtures.",
      products: [
        { id: 8, title: "Antique Copper Lamp", price: "€95" },
        { id: 14, title: "Crystal Chandelier", price: "€300" },
        { id: 15, title: "Art Deco Lamp", price: "€150" },
      ],
    },
    category: { id: "hg-4", name: "Lighting" },
    condition: "Very Good",
    rating: 4.8,
    reviewCount: 9,
    stallName: "Antique Lighting",
    stallId: 7,
    isFeatured: true,
    specifications: [
      { filterId: "height", value: 80, displayName: "Height" },
      { filterId: "width", value: 60, displayName: "Width" },
      { filterId: "depth", value: 60, displayName: "Depth" },
      { filterId: "assembly", value: "Full Assembly", displayName: "Assembly Required" },
      { filterId: "indoorOutdoor", value: "Indoor Only", displayName: "Usage" },
    ]
  },
  15: {
    id: 15,
    title: "Art Deco Table Lamp",
    price: "€150",
    description: "Stunning Art Deco lamp with geometric patterns. Fully restored and in excellent condition.",
    image: "/images/15_Art_Deco_Table_Lamp.png",
    stall: {
      id: 7,
      name: "Antique Lighting",
      description: "Specializing in vintage and antique lighting fixtures.",
      products: [
        { id: 8, title: "Antique Copper Lamp", price: "€95" },
        { id: 14, title: "Crystal Chandelier", price: "€300" },
        { id: 15, title: "Art Deco Lamp", price: "€150" },
      ],
    },
    category: { id: "hg-4-1", name: "Table Lamps" },
    condition: "Like New",
    rating: 4.7,
    reviewCount: 16,
    stallName: "Antique Lighting",
    stallId: 7,
    isFeatured: true,
    specifications: [
      { filterId: "height", value: 55, displayName: "Height" },
      { filterId: "width", value: 25, displayName: "Width" },
      { filterId: "depth", value: 25, displayName: "Depth" },
      { filterId: "assembly", value: "Minimal Assembly", displayName: "Assembly Required" },
      { filterId: "indoorOutdoor", value: "Indoor Only", displayName: "Usage" },
    ]
  },
  16: {
    id: 16,
    title: "Modern Graphic Novels",
    price: "€25",
    description: "Contemporary graphic novels including popular series and independent titles.",
    image: "/images/16_Modern_Graphic_Novels.png",
    stall: {
      id: 8,
      name: "Comic Vault",
      description: "Rare comic books and graphic novels from various eras.",
      products: [
        { id: 9, title: "Vintage Comic Books", price: "€45" },
        { id: 16, title: "Graphic Novels", price: "€25" },
        { id: 17, title: "Comic Art", price: "€60" },
      ],
    },
    category: { id: "bk-3-3", name: "Table Lamps" },
    condition: "Like New",
    rating: 4.6,
    reviewCount: 18,
    stallName: "Comic Vault",
    stallId: 8,
    isFeatured: true,
    specifications: [
      { filterId: "genre", value: "Fantasy", displayName: "Genre" },
      { filterId: "language", value: "English", displayName: "Language" },
      { filterId: "publicationYear", value: 2020, displayName: "Publication Year" },
      { filterId: "binding", value: "Hardcover", displayName: "Binding" },
      { filterId: "condition", value: "Like New", displayName: "Book Condition" },
    ]
  },
  17: {
    id: 17,
    title: "Original Comic Book Art",
    price: "€60",
    description: "Original artwork from classic comic books. Perfect for collectors and art enthusiasts.",
    image: "/images/17_Original_Comic_Book_Art.png",
    stall: {
      id: 8,
      name: "Comic Vault",
      description: "Rare comic books and graphic novels from various eras.",
      products: [
        { id: 9, title: "Vintage Comic Books", price: "€45" },
        { id: 16, title: "Graphic Novels", price: "€25" },
        { id: 17, title: "Comic Art", price: "€60" },
      ],
    },
    category: { id: "bk-3-4", name: "Indie Comics" },
    condition: "Very Good",
    rating: 4.9,
    reviewCount: 7,
    stallName: "Comic Vault",
    stallId: 8,
    isFeatured: true,
    specifications: [
      { filterId: "artType", value: "Comic Art", displayName: "Art Type" },
      { filterId: "medium", value: "Ink", displayName: "Medium" },
      { filterId: "handmade", value: "Handmade Only", displayName: "Handmade" },
      { filterId: "skillLevel", value: "Professional", displayName: "Skill Level" },
    ]
  },
  18: {
    id: 18,
    title: "Vintage Wool Sweater",
    price: "€65",
    description: "Cozy wool sweater from the 80s with classic Nordic patterns. Perfect for winter wear.",
    image: "/images/18_Vintage_Wool_Sweater.png",
    images: [
      "/images/18_Vintage_Wool_Sweater.png",
      "/images/18_Vintage_Wool_Sweater_2.png",
      "/images/18_Vintage_Wool_Sweater_3.png"
    ],
    variants: [
      // Two-step variant structure - sizes and their available colors
      {
        id: "size-s",
        name: "Size",
        value: "S",
        price: "€60",
        stock: 14, // Total stock across all colors for this size
        colors: [
          { id: "color-red", name: "Color", value: "Red Nordic", price: "€60", stock: 5 },
          { id: "color-blue", name: "Color", value: "Blue Nordic", price: "€60", stock: 2 },
          { id: "color-green", name: "Color", value: "Green Nordic", price: "€60", stock: 7 },
          { id: "color-gray", name: "Color", value: "Gray Nordic", price: "€60", stock: 0 }
        ]
      },
      {
        id: "size-m",
        name: "Size",
        value: "M",
        price: "€65",
        stock: 18, // Total stock across all colors for this size
        colors: [
          { id: "color-red", name: "Color", value: "Red Nordic", price: "€65", stock: 8 },
          { id: "color-blue", name: "Color", value: "Blue Nordic", price: "€65", stock: 0 }, // Out of stock
          { id: "color-green", name: "Color", value: "Green Nordic", price: "€65", stock: 4 },
          { id: "color-gray", name: "Color", value: "Gray Nordic", price: "€65", stock: 6 }
        ]
      },
      {
        id: "size-l",
        name: "Size",
        value: "L",
        price: "€65",
        stock: 29, // Total stock across all colors for this size
        colors: [
          { id: "color-red", name: "Color", value: "Red Nordic", price: "€65", stock: 12 },
          { id: "color-blue", name: "Color", value: "Blue Nordic", price: "€65", stock: 3 },
          { id: "color-green", name: "Color", value: "Green Nordic", price: "€65", stock: 9 },
          { id: "color-gray", name: "Color", value: "Gray Nordic", price: "€65", stock: 5 }
        ]
      },
      {
        id: "size-xl",
        name: "Size",
        value: "XL",
        price: "€70",
        stock: 6, // Total stock across all colors for this size
        colors: [
          { id: "color-red", name: "Color", value: "Red Nordic", price: "€70", stock: 3 },
          { id: "color-blue", name: "Color", value: "Blue Nordic", price: "€70", stock: 1 },
          { id: "color-green", name: "Color", value: "Green Nordic", price: "€70", stock: 2 },
          { id: "color-gray", name: "Color", value: "Gray Nordic", price: "€70", stock: 0 }
        ]
      }
    ],
    stall: {
      id: 1,
      name: "Vintage Style Co.",
      description: "Curated collection of authentic vintage clothing and accessories.",
      products: [
        { id: 1, title: "Vintage Suede Jacket", price: "€150" },
        { id: 2, title: "Denim Jeans", price: "€80" },
        { id: 18, title: "Vintage Wool Sweater", price: "€65" },
      ],
    },
    category: { id: "cl-2-3", name: "Sweaters" },
    condition: "Good",
    rating: 4.3,
    reviewCount: 25,
    stallName: "Vintage Style Co.",
    stallId: 1,
    isFeatured: true,
    specifications: [
      { filterId: "material", value: "Wool", displayName: "Material" },
      { filterId: "style", value: "Nordic", displayName: "Style" },
      { filterId: "pattern", value: "Patterned", displayName: "Pattern" },
    ]
  },
  19: {
    id: 19,
    title: "Antique Wooden Chair",
    price: "€180",
    description: "Beautiful antique wooden chair with carved details. Perfect for traditional home decor.",
    image: "/images/19_Antique_Wooden_Chair.png",
    stall: {
      id: 4,
      name: "Heritage Pieces",
      description: "Specializing in antique furniture and home decor items.",
      products: [
        { id: 4, title: "Antique Coffee Table", price: "€350" },
        { id: 8, title: "Vintage Chair", price: "€180" },
        { id: 19, title: "Antique Wooden Chair", price: "€180" },
      ],
    },
    category: { id: "hg-1-2", name: "Chairs" },
    condition: "Very Good",
    rating: 4.5,
    reviewCount: 11,
    stallName: "Heritage Pieces",
    stallId: 4,
    isFeatured: true,
    specifications: [
      { filterId: "height", value: 90, displayName: "Height" },
      { filterId: "width", value: 45, displayName: "Width" },
      { filterId: "depth", value: 50, displayName: "Depth" },
      { filterId: "weightCapacity", value: "Up to 100kg", displayName: "Weight Capacity" },
      { filterId: "assembly", value: "No Assembly", displayName: "Assembly Required" },
    ]
  },
  20: {
    id: 20,
    title: "Vintage Typewriter",
    price: "€180",
    description: "Classic manual typewriter from the 50s. Fully functional with original case.",
    image: "/images/20_Vintage_Typewriter.png",
    stall: {
      id: 3,
      name: "Retro Finds",
      description: "Specializing in vintage electronics and collectibles from the 20th century.",
      products: [
        { id: 3, title: "Vintage Camera Collection", price: "€200" },
        { id: 6, title: "Old Radio", price: "€85" },
        { id: 20, title: "Vintage Typewriter", price: "€180" },
      ],
    },
    category: { id: "cl-3-7", name: "Typewriters" },
    condition: "Good",
    rating: 4.4,
    reviewCount: 14,
    stallName: "Retro Finds",
    stallId: 3,
    isFeatured: true,
    specifications: [
      { filterId: "collectibleType", value: "Typewriters", displayName: "Collectible Type" },
      { filterId: "era", value: "1950s", displayName: "Era" },
      { filterId: "rarity", value: "Rare", displayName: "Rarity" },
      { filterId: "certified", value: "Original Case", displayName: "Certification" },
    ]
  },
  21: {
    id: 21,
    title: "Vintage Radio",
    price: "€85",
    description: "Classic tube radio from the 40s. Beautiful wooden case with original knobs and dial.",
    image: "/images/21_Vintage_Radio.png",
    stall: {
      id: 3,
      name: "Retro Finds",
      description: "Specializing in vintage electronics and collectibles from the 20th century.",
      products: [
        { id: 3, title: "Vintage Camera Collection", price: "€200" },
        { id: 20, title: "Vintage Typewriter", price: "€180" },
        { id: 21, title: "Vintage Radio", price: "€85" },
      ],
    },
    category: { id: "el-4-7", name: "Radios" },
    condition: "Good",
    rating: 4.2,
    reviewCount: 19,
    stallName: "Retro Finds",
    stallId: 3,
    isFeatured: true,
    specifications: [
      { filterId: "brand", value: "Philips", displayName: "Brand" },
      { filterId: "connectivity", value: ["Antenna"], displayName: "Connectivity" },
      { filterId: "storage", value: "Built-in Speaker", displayName: "Audio Output" },
    ]
  },
  22: {
    id: 22,
    title: "Handwoven Basket",
    price: "€35",
    description: "Beautiful handwoven basket made from natural fibers. Perfect for storage or decoration.",
    image: "/images/22_Handwoven_Basket.png",
    stall: {
      id: 2,
      name: "Lisboa Crafts",
      description: "Independent artisan collective selling handmade ceramics, textiles, and decor.",
      products: [
        { id: 2, title: "Handmade Ceramic Vase", price: "€75" },
        { id: 4, title: "Pottery Bowl", price: "€45" },
        { id: 22, title: "Handwoven Basket", price: "€35" },
      ],
    },
    category: { id: "hg-5-1", name: "Baskets" },
    condition: "Like New",
    rating: 4.6,
    reviewCount: 8,
    stallName: "Lisboa Crafts",
    stallId: 2,
    isFeatured: true,
    specifications: [
      { filterId: "height", value: 30, displayName: "Height" },
      { filterId: "width", value: 35, displayName: "Width" },
      { filterId: "depth", value: 35, displayName: "Depth" },
      { filterId: "assembly", value: "No Assembly", displayName: "Assembly Required" },
      { filterId: "indoorOutdoor", value: "Both Indoor & Outdoor", displayName: "Usage" },
    ]
  },
  23: {
    id: 23,
    title: "Pottery Bowl Set",
    price: "€45",
    description: "Set of three handmade pottery bowls in earth tones. Perfect for serving or decoration.",
    image: "/images/23_Pottery_Bowl_Set.png",
    stall: {
      id: 2,
      name: "Lisboa Crafts",
      description: "Independent artisan collective selling handmade ceramics, textiles, and decor.",
      products: [
        { id: 2, title: "Handmade Ceramic Vase", price: "€75" },
        { id: 22, title: "Handwoven Basket", price: "€35" },
        { id: 23, title: "Pottery Bowl Set", price: "€45" },
      ],
    },
    category: { id: "ac-4-1", name: "Pottery" },
    condition: "Like New",
    rating: 4.7,
    reviewCount: 13,
    stallName: "Lisboa Crafts",
    stallId: 2,
    isFeatured: true,
    specifications: [
      { filterId: "artType", value: "Pottery", displayName: "Art Type" },
      { filterId: "medium", value: "Clay", displayName: "Medium" },
      { filterId: "handmade", value: "Handmade Only", displayName: "Handmade" },
      { filterId: "skillLevel", value: "Advanced", displayName: "Skill Level" },
    ]
  },
  24: {
    id: 24,
    title: "Decorative Wall Plate",
    price: "€60",
    description: "Beautiful decorative wall plate with intricate hand-painted design. Perfect for kitchen or dining room.",
    image: "/images/24_Decorative_Wall_Plate.png",
    stall: {
      id: 2,
      name: "Lisboa Crafts",
      description: "Independent artisan collective selling handmade ceramics, textiles, and decor.",
      products: [
        { id: 2, title: "Handmade Ceramic Vase", price: "€75" },
        { id: 22, title: "Handwoven Basket", price: "€35" },
        { id: 24, title: "Decorative Wall Plate", price: "€60" },
      ],
    },
    category: { id: "hg-2-1-1", name: "Decorative Plates" },
    condition: "Like New",
    rating: 4.8,
    reviewCount: 9,
    stallName: "Lisboa Crafts",
    stallId: 2,
    isFeatured: true,
    specifications: [
      { filterId: "artType", value: "Decorative Art", displayName: "Art Type" },
      { filterId: "medium", value: "Ceramic", displayName: "Medium" },
      { filterId: "handmade", value: "Handmade Only", displayName: "Handmade" },
      { filterId: "skillLevel", value: "Expert", displayName: "Skill Level" },
    ]
  },
  25: {
    id: 25,
    title: "Vintage Wooden Cabinet",
    price: "€420",
    description: "Large antique wooden cabinet with glass doors. Perfect for displaying collectibles or storing items.",
    image: "/images/25_Vintage_Wooden_Cabinet.png",
    stall: {
      id: 4,
      name: "Heritage Pieces",
      description: "Specializing in antique furniture and home decor items.",
      products: [
        { id: 4, title: "Antique Coffee Table", price: "€350" },
        { id: 19, title: "Antique Wooden Chair", price: "€180" },
        { id: 25, title: "Vintage Wooden Cabinet", price: "€420" },
      ],
    },
    category: { id: "hg-1-3", name: "Cabinets" },
    condition: "Very Good",
    rating: 4.6,
    reviewCount: 6,
    stallName: "Heritage Pieces",
    stallId: 4,
    isFeatured: true,
    specifications: [
      { filterId: "height", value: 180, displayName: "Height" },
      { filterId: "width", value: 100, displayName: "Width" },
      { filterId: "depth", value: 45, displayName: "Depth" },
      { filterId: "weightCapacity", value: "Up to 200kg", displayName: "Weight Capacity" },
      { filterId: "assembly", value: "Minimal Assembly", displayName: "Assembly Required" },
    ]
  },
  26: {
    id: 26,
    title: "Vintage Polaroid Camera",
    price: "€90",
    description: "Classic Polaroid instant camera from the 80s. Includes original case and film packs.",
    image: "/images/26_Vintage_Polaroid_Camera.png",
    stall: {
      id: 3,
      name: "Retro Finds",
      description: "Specializing in vintage electronics and collectibles from the 20th century.",
      products: [
        { id: 3, title: "Vintage Camera Collection", price: "€200" },
        { id: 20, title: "Vintage Typewriter", price: "€180" },
        { id: 26, title: "Vintage Polaroid Camera", price: "€90" },
      ],
    },
    category: { id: "el-3-7", name: "Polaroid" },
    condition: "Good",
    rating: 4.3,
    reviewCount: 17,
    stallName: "Retro Finds",
    stallId: 3,
    isFeatured: true,
    specifications: [
      { filterId: "brand", value: "Polaroid", displayName: "Brand" },
      { filterId: "connectivity", value: ["Flash"], displayName: "Connectivity" },
      { filterId: "storage", value: "Instant Film", displayName: "Film Type" },
    ]
  },
  27: {
    id: 27,
    title: "Vintage Silk Scarf",
    price: "€55",
    description: "Elegant silk scarf with beautiful floral pattern. Perfect accessory for any outfit.",
    image: "/images/27_Vintage_Silk_Scarf.png",
    stall: {
      id: 1,
      name: "Vintage Style Co.",
      description: "Curated collection of authentic vintage clothing and accessories.",
      products: [
        { id: 1, title: "Vintage Suede Jacket", price: "€150" },
        { id: 18, title: "Vintage Wool Sweater", price: "€65" },
        { id: 27, title: "Vintage Silk Scarf", price: "€55" },
      ],
    },
    category: { id: "cl-5-4", name: "Scarves" },
    condition: "Very Good",
    rating: 4.5,
    reviewCount: 21,
    stallName: "Vintage Style Co.",
    stallId: 1,
    isFeatured: true,
    specifications: [
      { filterId: "size", value: "One Size", displayName: "Size" },
      { filterId: "material", value: "Silk", displayName: "Material" },
      { filterId: "style", value: "Floral", displayName: "Style" },
      { filterId: "pattern", value: "Floral", displayName: "Pattern" },
      { filterId: "color", value: "Multicolor", displayName: "Color" },
    ]
  },
  28: {
    id: 28,
    title: "Antique Silverware Set",
    price: "€120",
    description: "Complete set of antique silverware including forks, knives, and spoons. Beautifully engraved.",
    image: "/images/28_Antique_Silverware_Set.png",
    stall: {
      id: 4,
      name: "Heritage Pieces",
      description: "Specializing in antique furniture and home decor items.",
      products: [
        { id: 4, title: "Antique Coffee Table", price: "€350" },
        { id: 19, title: "Antique Wooden Chair", price: "€180" },
        { id: 28, title: "Antique Silverware Set", price: "€120" },
      ],
    },
    category: { id: "hg-3-1", name: "Silverware" },
    condition: "Very Good",
    rating: 4.7,
    reviewCount: 10,
    stallName: "Heritage Pieces",
    stallId: 4,
    isFeatured: true,
    specifications: [
      { filterId: "height", value: 5, displayName: "Height" },
      { filterId: "width", value: 25, displayName: "Width" },
      { filterId: "depth", value: 15, displayName: "Depth" },
      { filterId: "assembly", value: "No Assembly", displayName: "Assembly Required" },
      { filterId: "indoorOutdoor", value: "Indoor Only", displayName: "Usage" },
    ]
  },
  29: {
    id: 29,
    title: "Vintage Board Games",
    price: "€30",
    description: "Collection of classic board games from the 70s and 80s. Includes Monopoly, Scrabble, and more.",
    image: "/images/29_Vintage_Board_Games.png",
    stall: {
      id: 6,
      name: "Pixel Palace",
      description: "Vintage gaming consoles and classic video games.",
      products: [
        { id: 6, title: "Retro Gaming Console", price: "€180" },
        { id: 12, title: "Game Cartridges", price: "€15" },
        { id: 29, title: "Vintage Board Games", price: "€30" },
      ],
    },
    category: { id: "ga-1-4", name: "Classic" },
    condition: "Good",
    rating: 4.4,
    reviewCount: 16,
    stallName: "Pixel Palace",
    stallId: 6,
    isFeatured: true,
    specifications: [
      { filterId: "collectibleType", value: "Games", displayName: "Collectible Type" },
      { filterId: "era", value: "1970s", displayName: "Era" },
      { filterId: "rarity", value: "Common", displayName: "Rarity" },
      { filterId: "certified", value: "Not Certified", displayName: "Certification" },
    ]
  },
  30: {
    id: 30,
    title: "Vintage Postcards",
    price: "€20",
    description: "Collection of vintage postcards from various European cities. Perfect for collectors.",
    image: "/images/30_Vintage_Postcards.png",
    stall: {
      id: 8,
      name: "Comic Vault",
      description: "Rare comic books and graphic novels from various eras.",
      products: [
        { id: 9, title: "Vintage Comic Books", price: "€45" },
        { id: 16, title: "Graphic Novels", price: "€25" },
        { id: 30, title: "Vintage Postcards", price: "€20" },
      ],
    },
    category: { id: "co-7", name: "Postcards" },
    condition: "Good",
    rating: 4.2,
    reviewCount: 14,
    stallName: "Comic Vault",
    stallId: 8,
    isFeatured: true,
    specifications: [
      { filterId: "collectibleType", value: "Postcards", displayName: "Collectible Type" },
      { filterId: "era", value: "1920s", displayName: "Era" },
      { filterId: "rarity", value: "Uncommon", displayName: "Rarity" },
      { filterId: "certified", value: "Not Certified", displayName: "Certification" },
    ]
  },
  31: {
    id: 31,
    title: "Vintage Suede Boots",
    price: "€95",
    description: "Classic Suede boots from the 70s. Well-maintained with beautiful patina.",
    image: "/images/31_Vintage_Suede_Boots.png",
    stall: {
      id: 1,
      name: "Vintage Style Co.",
      description: "Curated collection of authentic vintage clothing and accessories.",
      products: [
        { id: 1, title: "Vintage Suede Jacket", price: "€150" },
        { id: 18, title: "Vintage Wool Sweater", price: "€65" },
        { id: 31, title: "Vintage Suede Boots", price: "€95" },
      ],
    },
    category: { id: "cl-4-2", name: "Boots" },
    condition: "Good",
    rating: 4.3,
    reviewCount: 18,
    stallName: "Vintage Style Co.",
    stallId: 1,
    isFeatured: true,
    specifications: [
      { filterId: "size", value: "42", displayName: "Size" },
      { filterId: "material", value: "Suede", displayName: "Material" },
      { filterId: "style", value: "Classic", displayName: "Style" },
      { filterId: "pattern", value: "Solid", displayName: "Pattern" },
      { filterId: "color", value: "Brown", displayName: "Color" },
    ]
  },
  32: {
    id: 32,
    title: "Antique Mirror Frame",
    price: "€75",
    description: "Beautiful antique mirror frame with ornate gold detailing. Perfect for vintage home decor.",
    image: "/images/32_Antique_Mirror_Frame.png",
    stall: {
      id: 4,
      name: "Heritage Pieces",
      description: "Specializing in antique furniture and home decor items.",
      products: [
        { id: 4, title: "Antique Coffee Table", price: "€350" },
        { id: 19, title: "Antique Wooden Chair", price: "€180" },
        { id: 32, title: "Antique Mirror Frame", price: "€75" },
      ],
    },
    category: { id: "hg-2-3", name: "Mirrors" },
    condition: "Very Good",
    rating: 4.5,
    reviewCount: 12,
    stallName: "Heritage Pieces",
    stallId: 4,
    isFeatured: true,
    specifications: [
      { filterId: "height", value: 60, displayName: "Height" },
      { filterId: "width", value: 45, displayName: "Width" },
      { filterId: "depth", value: 5, displayName: "Depth" },
      { filterId: "assembly", value: "No Assembly", displayName: "Assembly Required" },
      { filterId: "indoorOutdoor", value: "Indoor Only", displayName: "Usage" },
    ]
  },
  33: {
    id: 33,
    title: "Vintage Film Camera",
    price: "€130",
    description: "Classic 35mm film camera from the 60s. Includes original Suede case and manual.",
    image: "/images/33_Vintage_Film_Camera.png",
    stall: {
      id: 3,
      name: "Retro Finds",
      description: "Specializing in vintage electronics and collectibles from the 20th century.",
      products: [
        { id: 3, title: "Vintage Camera Collection", price: "€200" },
        { id: 26, title: "Vintage Polaroid Camera", price: "€90" },
        { id: 33, title: "Vintage Film Camera", price: "€130" },
      ],
    },
    category: { id: "el-3", name: "Cameras" },
    condition: "Good",
    rating: 4.4,
    reviewCount: 15,
    stallName: "Retro Finds",
    stallId: 3,
    isFeatured: true,
    specifications: [
      { filterId: "brand", value: "Canon", displayName: "Brand" },
      { filterId: "connectivity", value: ["Flash", "Tripod Mount"], displayName: "Connectivity" },
      { filterId: "storage", value: "35mm Film", displayName: "Film Type" },
    ]
  },
  34: {
    id: 34,
    title: "Vintage Tea Set",
    price: "€85",
    description: "Complete vintage tea set with teapot, cups, and saucers. Beautiful floral pattern.",
    image: "/images/34_Vintage_Tea_Set.png",
    stall: {
      id: 2,
      name: "Lisboa Crafts",
      description: "Independent artisan collective selling handmade ceramics, textiles, and decor.",
      products: [
        { id: 2, title: "Handmade Ceramic Vase", price: "€75" },
        { id: 23, title: "Pottery Bowl Set", price: "€45" },
        { id: 34, title: "Vintage Tea Set", price: "€85" },
      ],
    },
    category: { id: "hg-3-2", name: "Tea Sets" },
    condition: "Very Good",
    rating: 4.6,
    reviewCount: 11,
    stallName: "Lisboa Crafts",
    stallId: 2,
    isFeatured: true,
    specifications: [
      { filterId: "height", value: 15, displayName: "Height" },
      { filterId: "width", value: 25, displayName: "Width" },
      { filterId: "depth", value: 20, displayName: "Depth" },
      { filterId: "assembly", value: "No Assembly", displayName: "Assembly Required" },
      { filterId: "indoorOutdoor", value: "Indoor Only", displayName: "Usage" },
    ]
  },
  35: {
    id: 35,
    title: "Retro-chic eyewear",
    price: "€45",
    description: "Classic aviator sunglasses from the 80s. Perfect vintage accessory.",
    image: "/images/35_Retro-chic_eyewear.png",
    stall: {
      id: 1,
      name: "Vintage Style Co.",
      description: "Curated collection of authentic vintage clothing and accessories.",
      products: [
        { id: 1, title: "Vintage Suede Jacket", price: "€150" },
        { id: 27, title: "Vintage Silk Scarf", price: "€55" },
        { id: 35, title: "Vintage Sunglasses", price: "€45" },
      ],
    },
    category: { id: "cl-5-7", name: "Sunglasses" },
    condition: "Good",
    rating: 4.3,
    reviewCount: 20,
    stallName: "Vintage Style Co.",
    stallId: 1,
    isFeatured: true,
    specifications: [
      { filterId: "size", value: "One Size", displayName: "Size" },
      { filterId: "material", value: "Metal", displayName: "Material" },
      { filterId: "style", value: "Aviator", displayName: "Style" },
      { filterId: "pattern", value: "Solid", displayName: "Pattern" },
      { filterId: "color", value: "Gold", displayName: "Color" },
    ]
  },
  36: {
    id: 36,
    title: "Antique Clock",
    price: "€110",
    description: "Beautiful antique wall clock with pendulum. Keeps perfect time after restoration.",
    image: "/images/36_Antique_Clock.png",
    stall: {
      id: 4,
      name: "Heritage Pieces",
      description: "Specializing in antique furniture and home decor items.",
      products: [
        { id: 4, title: "Antique Coffee Table", price: "€350" },
        { id: 28, title: "Antique Silverware Set", price: "€120" },
        { id: 36, title: "Antique Clock", price: "€110" },
      ],
    },
    category: { id: "hg-6-1", name: "Clocks" },
    condition: "Very Good",
    rating: 4.7,
    reviewCount: 8,
    stallName: "Heritage Pieces",
    stallId: 4,
    isFeatured: true,
    specifications: [
      { filterId: "height", value: 40, displayName: "Height" },
      { filterId: "width", value: 30, displayName: "Width" },
      { filterId: "depth", value: 10, displayName: "Depth" },
      { filterId: "assembly", value: "No Assembly", displayName: "Assembly Required" },
      { filterId: "indoorOutdoor", value: "Indoor Only", displayName: "Usage" },
    ]
  },
  37: {
    id: 37,
    title: "Vintage Tapes",
    price: "€15",
    description: "Collection of classic cassette tapes from the 80s. Includes popular artists and albums.",
    image: "/images/37_Vintage_Tapes.jpg",
    stall: {
      id: 5,
      name: "Music Memorabilia",
      description: "Rare vinyl records and music memorabilia from various eras.",
      products: [
        { id: 5, title: "Vintage Vinyl Records", price: "€25" },
        { id: 10, title: "Record Player", price: "€120" },
        { id: 37, title: "Vintage Cassette Tapes", price: "€15" },
      ],
    },
    category: { id: "co-5-1", name: "Music" },
    condition: "Good",
    rating: 4.1,
    reviewCount: 13,
    stallName: "Music Memorabilia",
    stallId: 5,
    isFeatured: true,
    specifications: [
      { filterId: "brand", value: "Sony", displayName: "Brand" },
      { filterId: "connectivity", value: ["3.5mm Audio"], displayName: "Connectivity" },
      { filterId: "storage", value: "Cassette Tape", displayName: "Media Type" },
    ]
  },
  38: {
    id: 38,
    title: "Vintage Toy Collection",
    price: "€70",
    description: "Collection of classic toys from the 70s and 80s. Perfect for collectors or as gifts.",
    image: "/images/38_Vintage_Toy_Collection.png",
    stall: {
      id: 6,
      name: "Pixel Palace",
      description: "Vintage gaming consoles and classic video games.",
      products: [
        { id: 6, title: "Retro Gaming Console", price: "€180" },
        { id: 29, title: "Vintage Board Games", price: "€30" },
        { id: 38, title: "Vintage Toy Collection", price: "€70" },
      ],
    },
    category: { id: "co-4", name: "Toys" },
    condition: "Good",
    rating: 4.5,
    reviewCount: 9,
    stallName: "Pixel Palace",
    stallId: 6,
    isFeatured: true,
    specifications: [
      { filterId: "collectibleType", value: "Toys", displayName: "Collectible Type" },
      { filterId: "era", value: "1970s", displayName: "Era" },
      { filterId: "rarity", value: "Uncommon", displayName: "Rarity" },
      { filterId: "certified", value: "Not Certified", displayName: "Certification" },
    ]
  },
  39: {
    id: 39,
    title: "Vintage Maps",
    price: "€35",
    description: "Collection of vintage maps from the early 20th century. Perfect for framing or collecting.",
    image: "/images/39_Vintage_Maps.png",
    stall: {
      id: 8,
      name: "Comic Vault",
      description: "Rare comic books and graphic novels from various eras.",
      products: [
        { id: 9, title: "Vintage Comic Books", price: "€45" },
        { id: 30, title: "Vintage Postcards", price: "€20" },
        { id: 39, title: "Vintage Maps", price: "€35" },
      ],
    },
    category: { id: "co", name: "Collectibles" },
    condition: "Good",
    rating: 4.3,
    reviewCount: 7,
    stallName: "Comic Vault",
    stallId: 8,
    isFeatured: true,
    specifications: [
      { filterId: "collectibleType", value: "Maps", displayName: "Collectible Type" },
      { filterId: "era", value: "1900s", displayName: "Era" },
      { filterId: "rarity", value: "Rare", displayName: "Rarity" },
      { filterId: "certified", value: "Not Certified", displayName: "Certification" },
    ]
  },
  40: {
    id: 40,
    title: "Vintage Handbag",
    price: "€75",
    description: "Elegant vintage handbag from the 60s. Genuine Suede with classic design.",
    image: "/images/40_Vintage_Handbag.png",
    stall: {
      id: 1,
      name: "Vintage Style Co.",
      description: "Curated collection of authentic vintage clothing and accessories.",
      products: [
        { id: 1, title: "Vintage Suede Jacket", price: "€150" },
        { id: 27, title: "Vintage Silk Scarf", price: "€55" },
        { id: 40, title: "Vintage Handbag", price: "€75" },
      ],
    },
    category: { id: "cl-5-1", name: "Bags" },
    condition: "Very Good",
    rating: 4.4,
    reviewCount: 16,
    stallName: "Vintage Style Co.",
    stallId: 1,
    isFeatured: true,
    specifications: [
      { filterId: "size", value: "Medium", displayName: "Size" },
      { filterId: "material", value: "Suede", displayName: "Material" },
      { filterId: "style", value: "Classic", displayName: "Style" },
      { filterId: "pattern", value: "Solid", displayName: "Pattern" },
      { filterId: "color", value: "Brown", displayName: "Color" },
    ]
  },
  41: {
    id: 41,
    title: "Antique Vase",
    price: "€95",
    description: "Beautiful antique vase with hand-painted floral design. Perfect for collectors.",
    image: "/images/41_Antique_Vase.png",
    stall: {
      id: 2,
      name: "Lisboa Crafts",
      description: "Independent artisan collective selling handmade ceramics, textiles, and decor.",
      products: [
        { id: 2, title: "Handmade Ceramic Vase", price: "€75" },
        { id: 34, title: "Vintage Tea Set", price: "€85" },
        { id: 41, title: "Antique Vase", price: "€95" },
      ],
    },
    category: { id: "hg-2-4", name: "Vases" },
    condition: "Very Good",
    rating: 4.6,
    reviewCount: 10,
    stallName: "Lisboa Crafts",
    stallId: 2,
    isFeatured: true,
    specifications: [
      { filterId: "artType", value: "Decorative Art", displayName: "Art Type" },
      { filterId: "medium", value: "Ceramic", displayName: "Medium" },
      { filterId: "handmade", value: "Handmade Only", displayName: "Handmade" },
      { filterId: "skillLevel", value: "Master", displayName: "Skill Level" },
    ]
  },
  42: {
    id: 42,
    title: "Vintage Wristwatch",
    price: "€120",
    description: "Classic mechanical wristwatch from the 50s. Fully restored and keeping perfect time.",
    image: "/images/42_Vintage_Wristwatch.png",
    stall: {
      id: 1,
      name: "Vintage Style Co.",
      description: "Curated collection of authentic vintage clothing and accessories.",
      products: [
        { id: 1, title: "Vintage Suede Jacket", price: "€150" },
        { id: 35, title: "Vintage Sunglasses", price: "€45" },
        { id: 42, title: "Vintage Wristwatch", price: "€120" },
      ],
    },
    category: { id: "cl-5-8", name: "Watches" },
    condition: "Very Good",
    rating: 4.7,
    reviewCount: 14,
    stallName: "Vintage Style Co.",
    stallId: 1,
    isFeatured: true,
    specifications: [
      { filterId: "size", value: "One Size", displayName: "Size" },
      { filterId: "material", value: "Metal", displayName: "Material" },
      { filterId: "style", value: "Classic", displayName: "Style" },
      { filterId: "pattern", value: "Solid", displayName: "Pattern" },
      { filterId: "color", value: "Silver", displayName: "Color" },
    ]
  },
};

// Helper function to get a product by ID
export function getProductById(id: number): IProduct | undefined {
  return productListings[id];
}

// Helper function to get all products
export function getAllProducts(): IProduct[] {
  return Object.values(productListings);
}

// Helper function to get all products
export function getFeaturedProducts(): IProduct[] {
  const allProducts = Object.values(productListings)
  
  return [...allProducts.filter(k=>k.isFeatured == true)];
}

// Helper function to search products by title
export function searchProducts(query: string): IProduct[] {
  const lowercaseQuery = query.toLowerCase();
  return Object.values(productListings).filter(product =>
    product.title.toLowerCase().includes(lowercaseQuery)
  );
}
